import { render } from "./ModelListCards.vue?vue&type=template&id=4f424ea9&scoped=true"
import script from "./ModelListCards.vue?vue&type=script&lang=js"
export * from "./ModelListCards.vue?vue&type=script&lang=js"

import "./ModelListCards.vue?vue&type=style&index=0&id=4f424ea9&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f424ea9"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable});
